import {
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel
} from "@mui/material";
import { BaseKey } from "@refinedev/core";
import type { ListProps } from "@refinedev/mui";
import { config } from "config";
import React, { useEffect, useState } from "react";
import { dataProvider } from "rest-data-provider";

type ExtendedListProps = ListProps & {
  id: BaseKey | undefined;
};

const MenuAuthority = [
  "badges",
  "bad-words",
  "common-reasons",
  "badge-rules",
  "message-incidents",
  "quotestream-packages",
  "prod-categories",
  "products",
  "reported-messages",
  "uri-reviews",
  "role-badge-relations",
  "rooms",
  "settings",
  "stream-vendors",
  "tickets",
  "symbols",
  "users",
  "user-badges",
  "delist-positions",
  "orca-deployer",
  "orca-developer",
];

const MenuMap: any = {
  "Badge rules": "Followers settings",
  "Prod categories": "Product categories",
  "Uri reviews": "Reviews",
  "Role badge relations": "Role badges assignments",
  "Orca deployer": "Orca deployment",
  "Orca developer": "Orca deploy activity logs",
};

const All = "all";

export const AuthorityList: React.FC<ExtendedListProps> = ({
  wrapperProps,
  id,
}) => {
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const apiUrl = config().server.api;

  const handleSave = () => {
    dataProvider(apiUrl).update({
      resource: "user/profile",
      id: id ?? "",
      variables: {
        authority,
      },
    });
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleMenu = (init: any, checked: boolean) => {
    const res = MenuAuthority.reduce((pre, curr) => {
      return { ...pre, [curr]: checked };
    }, init);
    return res;
  };

  const [authority, setAuthority] = React.useState<any>(handleMenu({}, false));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const checked = event.target.checked;
    if (name === All) {
      const temp = handleMenu(authority, checked);
      setAuthority(temp);
    } else {
      setAuthority({
        ...authority,
        [event.target.name]: event.target.checked,
      });
    }
  };

  useEffect(() => {
    dataProvider(apiUrl)
      .getOne({
        resource: "user",
        id: id ?? "",
      })
      .then((res) => {
        setAuthority((pre: any) => {
          return { ...pre, ...res.data.authority };
        });
      });
  }, [apiUrl, id]);

  const checkSelect = (): boolean => {
    return MenuAuthority.every((e) => (authority as any)[e]);
  };

  return (
    <Card {...(wrapperProps ?? {})}>
      <CardHeader
        sx={{ display: "flex", flexWrap: "wrap" }}
        color="blue"
        title="Authority"
        action={
          <Box display="flex" gap="16px">
            <Button variant="outlined" onClick={handleClickOpen}>
              Modify Authority
            </Button>
          </Box>
        }
      />
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ display: "flex", flexDirection: "column" }}
            autoComplete="off"
          >
            <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
              <FormLabel component="legend">Assign responsibility</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={checkSelect()}
                      onChange={handleChange}
                      name={All}
                    />
                  }
                  label="All"
                />
                {MenuAuthority.map((e: string) => {
                  let label = e.replace(/-/g, " ");
                  label = label[0].toUpperCase() + label.slice(1);
                  return (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={authority[e]}
                          onChange={handleChange}
                          name={e}
                        />
                      }
                      label={MenuMap[label] || label}
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
